module.exports = __webpack_public_path__ + "static/media/Breach.4ccbf409.png";